import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 *
 *  reset GTM modelData from previous page on client side route change
 */
var useGtmResetOnRouteChange = function () {
    var location = useLocation();
    useEffect(function () {
        // reset GTM on client side route changes
        window.dataLayer.push(function () {
            this.reset();
        });
        // only path but no query params changes
    }, [location.pathname]);
};
export default useGtmResetOnRouteChange;
